import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from '../redux/actions'
import topInformationSelector from '../redux/selectors/top_information/top_information_selector'

import Information from '../views/information/information_top/information_top'

class TopInformationsController extends Component {

	render() {

		const informationCloseHandler = id => {
			this.props.actions.closeMessage(id, 'topInformation')
		}

		const isVisible = !!this.props.topInformation
		const informationElement = this.props.topInformation || {}

		return (
			<Information
				visible={isVisible}
				timeout={informationElement.timeout}
				styleType={informationElement.styleType}
				afterCallback={informationElement.afterCallback}
				onInformationClose={informationCloseHandler}
				informationId={informationElement.uid}
				showCloseBtn={informationElement.showCloseBtn}
				delay={informationElement.delay}
				linkText={informationElement.linkText}
				linkUrl={informationElement.linkUrl}
			>
				{informationElement.message}
			</Information>
		)

	}

}

TopInformationsController.propTypes = {
	actions: PropTypes.object,
	topInformation: PropTypes.object,
}

function mapStateToProps(state) {
	return topInformationSelector(state)
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TopInformationsController)
